import { gql, useLazyQuery } from '@apollo/client'

import type { StockProductInput } from '../types'

const CHECK_PRODUCTS_IN_STOCK_QUERY = gql`
  query CheckProductsInStock($productData: StockProductInput!) {
    checkProductsInStock(productData: $productData) {
      error_code
      message
      max_amount
      productInfo {
        id
        name
      }
      product_id
    }
  }
`

export interface CheckProductsInStockResult {
  error_code?: string
  message?: string
  max_amount?: number
  productInfo?: {
    id: string
    name: string
  }
  product_id: string
}

export interface CheckProductsInStockVariables {
  productData: StockProductInput
}

export interface CheckProductsInStockResponse {
  checkProductsInStock: CheckProductsInStockResult[]
}

export function useFetchCheckProductsInStock () {
  return useLazyQuery<CheckProductsInStockResponse, CheckProductsInStockVariables>(
    CHECK_PRODUCTS_IN_STOCK_QUERY,
    { fetchPolicy: 'no-cache' }
  )
}
